import EventEmitter from 'events';
import _ from 'lodash';
import { memo, useCallback, useEffect, useState } from 'react';

import { AddToastEvent } from './helper';
import Toast, { ToastProps } from './Toast';

export interface ToastContainerProps {
  id?: string;
  positionBottom?: boolean;
}

export const toastEvent = new EventEmitter();

const ToastContainer = ({ positionBottom, id }: ToastContainerProps) => {
  const [notifications, setNotifications] = useState<ToastProps[]>([]);

  const topNotifications = notifications.filter((n) => n.position === 'top-right');
  const bottomNotifications = notifications.filter((n) => n.position === 'bottom-right');

  const addToast = useCallback(
    (toastArgs: ToastProps) => {
      setNotifications((prevNotifications) => {
        const newNotifications = _.cloneDeep(prevNotifications);
        newNotifications.push({ id: _.uniqueId(), ...toastArgs });
        return newNotifications;
      });
    },
    [setNotifications]
  );

  useEffect(() => {
    toastEvent.on(AddToastEvent, addToast);
    return () => {
      toastEvent.off(AddToastEvent, addToast);
    };
  }, [addToast]);

  const handleClose = useCallback(
    (id?: string) => {
      setNotifications((prevNotifications) => {
        const newNotifications = _.cloneDeep(prevNotifications);
        return newNotifications.filter((notification) => notification.id !== id);
      });
    },
    [setNotifications]
  );

  return (
    <div data-testid="toast-container-component" id={id}>
      {/* Top container */}
      <div
        className="pointer-events-none fixed right-4 top-4 z-[999] flex flex-col items-end space-y-4"
        id={id}
      >
        {topNotifications.map((notificationProps) => (
          <Toast key={notificationProps.id} {...notificationProps} onClose={handleClose} />
        ))}
      </div>

      {/* Bottom container */}
      <div
        className="pointer-events-none fixed bottom-4 right-4 z-[999] flex flex-col items-end space-y-4"
        id={id}
      >
        {bottomNotifications.map((notificationProps) => (
          <Toast key={notificationProps.id} {...notificationProps} onClose={handleClose} />
        ))}
      </div>
    </div>
  );
};

export default memo(ToastContainer);
